<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>创建客户</h4>
        </div>
        <div class="main-bd mg20">
            <el-row>
                <el-col :span="10">
                    <SubForm @submit="submitForm" :key="sub_form_key"></SubForm>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import CustomerService from "~/services/customer";
import CustomerStdService from "~/services/CustomerStd";
import SubForm from "~/views/customer-std/form.vue";

export default {
    components: {
        SubForm
    },

    data() {
        return {
            sub_form_key: 0,
        };
    },

    created() {
        
    },

    methods: {
        submitForm(customer, reset_form_callback) {
            CustomerStdService.create(customer).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message:'创建成功',
                        type:'success'
                    });
                    this.sub_form_key ++;
                    this.$router.push({ path: "/customer-std/index"});
                }
            })
        }
    }
    
};
</script>


// WEBPACK FOOTER //
// src/views/customer-std/create.vue